export default __webpack_public_path__ + "static/media/v45_53.173979af.png";